$('body').on('initScripts pageTransitionComplete', function() {
    const toggledClass = 'item--toggled';

    // expandable items
    $('.expandable-items .item .item__toggle').off('click');
    $('.expandable-items .item .item__toggle').on('click', function (e) {
        e.preventDefault();

        let $item = $(this).closest('.item');

        if ($item.hasClass(toggledClass)) {
            $item.removeClass(toggledClass);
        } else {
            $item.addClass(toggledClass);
        }

        $(this).blur();
    });
});
